export default __webpack_public_path__ + "img/504cf966a4cc7465c9d3556503c90792.svg";